import { render, staticRenderFns } from "./EditTariffPage.vue?vue&type=template&id=428522ff&scoped=true&"
import script from "./EditTariffPage.vue?vue&type=script&lang=js&"
export * from "./EditTariffPage.vue?vue&type=script&lang=js&"
import style0 from "./EditTariffPage.vue?vue&type=style&index=0&id=428522ff&prod&lang=scss&scoped=true&"
import style1 from "./EditTariffPage.vue?vue&type=style&index=1&id=428522ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428522ff",
  null
  
)

export default component.exports